// src/curated/dmc/dmcTrips.js
// DMC trips shipped with the app. The partner hub's copy wins when it's connected; these keep the
// pages working before that, and are seeded into the demo hub.
import { KASHMIR_VERTICAL_TOURS } from "./kashmirVerticalTours";

export const DMC_SEED_TRIPS = [KASHMIR_VERTICAL_TOURS];

/** Seed trip by partner slug + trip slug (partner slug optional) */
export const findDmcSeed = (partnerSlug, slug) =>
    DMC_SEED_TRIPS.find((t) => (t.slug === slug || (t.aliases || []).includes(slug)) && (!partnerSlug || t.partner?.slug === partnerSlug)) || null;

export const dmcSeedsFor = (partnerSlug) => DMC_SEED_TRIPS.filter((t) => t.partner?.slug === partnerSlug);

export const dmcTripPath = (trip) => `/dmc/${trip.partner?.slug}/${trip.slug}`;
